export const steps = [
    'Campaign Details',
    'Define Scope',
    'Assign Scenario & Voice',
    'Done'
  ];

export const DEFAULT_MAX_REDIALS = 2;
export const MAX_REDIALS_LIMIT = 5;

export const MAX_REDIAL_OPTIONS = Array.from(
  { length: MAX_REDIALS_LIMIT + 1 },
  (_, maxRedials) => ({
    value: maxRedials,
    label: `${maxRedials} Redial${maxRedials === 1 ? '' : 's'}`
  })
);

export const normalizeMaxRedials = (value) => {
  if (value === null || value === undefined || value === '') return DEFAULT_MAX_REDIALS;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 0 && parsed <= MAX_REDIALS_LIMIT
    ? parsed
    : DEFAULT_MAX_REDIALS;
};

export const resolveMaxRedials = (value, fallback = 4) => {
  if (value === null || value === undefined || value === '') return fallback;
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : fallback;
};

export const formatAttemptPolicy = (value, fallback = 4) => {
  const maxRedials = resolveMaxRedials(value, fallback);
  return `${maxRedials} Redial${maxRedials === 1 ? '' : 's'}`;
};
